'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var unpkgJson = require('unpkg-json');

/**
 * load package.json from npm registory.
 */

var PackageJsonLoader = function () {
  /**
   * initialize PackageJsonLoader.
   * @param {String} pkgName : package name
   * @param {String} version : package version
   * @param {Boolean} unpkg : use unpkg.com for registry
   */
  function PackageJsonLoader(pkgName, version) {
    _classCallCheck(this, PackageJsonLoader);

    this._pkgName = pkgName;
    this._version = version;
    this._unpkgJson = unpkgJson;
  }

  /**
   * load package json.
   * if pkgName was configured, search package.json at npm registry.
   * if pkgName was not configured, throws error
   * @returns {Promise} resolve with package.json
   */


  _createClass(PackageJsonLoader, [{
    key: 'load',
    value: function load() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (!_this._pkgName) {
          reject(new Error('pkgName is required'));
        } else {
          _this._fetchPackageJson().then(function (result) {
            resolve(result);
          }).catch(function (err) {
            reject(err);
          });
        }
      });
    }

    /**
     * fetch package json from npm registry.
     * @param {String} pkgName
     * @returns {Promise} package.json
     */

  }, {
    key: '_fetchPackageJson',
    value: function _fetchPackageJson() {
      var name = this._pkgName;
      if (this._version) {
        name = this._pkgName + '@' + this._version;
      }
      return this._unpkgJson(name);
    }
  }]);

  return PackageJsonLoader;
}();

module.exports = PackageJsonLoader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dpndon/dist/npm/package-json-loader.js
// module id = 780
// module chunks = 0